export const translations = {
  zh: {
    // Header
    home: "首页",
    technology: "核心技术",
    solutions: "解决方案",
    apiDoc: "API文档",
    about: "关于我们",
    navSite: "站点导航",
    navAccount: "个人管理",
    login: "登录",
    logout: "退出登录",
    welcome: "欢迎，",
    
    // Footer
    footerCompanyDesc: "Stabilize-AI宁波如动科技是核心技术世界领先的人工智能科技公司，通过提供基于新理论的人工智能技术，让人工智能可以更好的应用在自动化、机器人和智慧世界等领域，为人工智能的应用开辟了广阔的疆土。",
    quickAccess: "快捷访问",
    subscribe: "订阅我们",
    emailPlaceholder: "输入您的邮箱，保持沟通",
    subscribeDescription: "通过订阅，您将及时获取到Stabilize-AI宁波如动科技的最新动态",
    footerAddressTitle: "地址",
    footerAddress: "浙江省宁波市江北区定英路369号文创港二期15幢2楼",
    footerBusinessTitle: "商业咨询",
    footerBusinessDesc: "欢迎投资和洽谈商业合作！",
    footerBusinessEmail: "business@stabilize-ai.com",
    footerJoinTitle: "我们期待您的加入！",
    footerJoinEmail: "hr@stabilize-ai.com",
    copyright: "© Stabilize-AI 宁波如动科技 版权所有",
    contact: "联系我们",
    contactModalTitle: "欢迎留言，我们期待与您交流",
    contactModalName: "姓名",
    contactModalEmail: "邮箱",
    contactModalNamePlaceholder: "您的姓名",
    contactModalEmailPlaceholder: "您的邮箱",
    contactModalSubject: "标题",
    contactModalContent: "内容",
    contactModalSend: "提交信息",
    contactModalSuccess: "已发送，我们会尽快与您联系。",
    contactModalNameRequired: "请输入姓名",
    contactModalEmailRequired: "请输入邮箱",
    contactModalEmailInvalid: "请输入有效的邮箱地址",
    contactModalSubjectRequired: "请输入标题",
    contactModalContentRequired: "请输入内容",
    products: "产品矩阵",
    
    // Common
    language: "语言",
    languageZh: "中文",
    languageEn: "English",
    
    // Home Page
    homeHero1Title: "新一代人工智能",
    homeHero1Desc: "具备自主学习和探索能力的真正的人工智能，具备自然生命的智力属性。",
    homeHero1Button1: "探索产品",
    homeHero1Button2: "API文档",
    homeHero2Title: "实现人工智能技术的产品化",
    homeHero2Desc: "包括可学习自动控制模型和芯片、可学习模型和芯片等多种产品形态。",
    homeHero2Button1: "了解更多",
    homeHero2Button2: "查看案例",
    homeHero3Title: "提供生产力，助力机器人产业的落地",
    homeHero3Desc: "应用领域包括自动化领域、机器人领域和广义机器人领域。",
    homeHero3Button1: "了解更多",
    homeHero3Button2: "联系我们",
    homeCoreFeaturesTag: "核心功能",
    homeCoreFeaturesTitle: "强大的AI智能软件服务，赋能各类电子产品",
    homeCoreFeaturesDesc: "一款可以嵌入到各类电子产品中的AI智能软件服务，让您的产品拥有智能化体验，提升产品竞争力。",
    homeCoreFeature1: "双杆倒立摆的平衡与控制，展示复杂系统的智能稳定控制能力。",
    homeCoreFeature1VideoIntro: "小狗学习行走：展示可学习模型在运动平衡中的自主学习能力。",
    videoLoading: "视频加载中…",
    homeCoreFeature2: "复杂环境中的路径规划与寻路决策，智能体自主探索并到达目标。",
    homeCoreFeature2VideoIntro: "PuppyPi 学习跟踪目标：展示可学习模型在视觉跟踪中的能力。",
    homeCoreFeature3: "受限条件下的小车爬山，通过自主学习在约束中达成目标。",
    homeCoreFeature3VideoIntro: "机器小人学习行走：展示可学习模型在双足运动控制中的能力。",
    homeCoreFeature4: "多节体蛇形运动控制，实现连续体的协调与目标追踪。",
    homeCoreFeature4VideoIntro: "小车避光运动：展示可学习模型在实时感知与运动决策中的能力。",
    homeCoreFeature5: "环境中的觅食与采集决策，智能规划动作序列完成任务。",
    homeCoreFeature5VideoIntro: "小车追光运动：展示可学习模型的环境感知和运动响应能力。",
    homeCoreFeature6: "多节体运动控制与协调，实现连续体的灵活运动。",
    homeCoreFeature6VideoIntro: "小车跟随人运动：展示可学习模型的动态目标感知与持续行为调整能力。",
    homeQuickStartTag: "快速使用",
    homeQuickStartTitle: "快速实现设备的智能化",
    homeQuickStartStep1Title: "选择产品和方案",
    homeQuickStartStep1Desc: "根据你的设备情况，选择合适的产品和集成方案。",
    homeQuickStartStep2Title: "集成产品到你的设备",
    homeQuickStartStep2Desc: "将我们的产品安装到你的设备，可以参考相关产品的获取和使用文档。",
    homeQuickStartStep3Title: "测试和调试",
    homeQuickStartStep3Desc: "你可以在你的设备上进行充分的测试和调试，由于模型具备自主学习能力，你可能需要让它自主学习一会儿，直到它的表现符合你的需求。",
    homeQuickStartStep4Title: "设备发布",
    homeQuickStartStep4Desc: "你可以将符合指标的智能化设备正式的销售到终端客户。",
    homeSDKDownloading: "正在获取{platform}版本SDK下载链接...",
    homeSDKDownloadSuccess: "{platform}版本SDK下载链接已生成，下载即将开始",
    homeSDKDownloadError: "SDK下载失败: {error}",
    homeSDKNotAvailable: "{platform}版本SDK尚未发布，敬请期待！",
    homeSDKDownloadFailed: "SDK下载失败",
    homeSDKRetryLater: "请稍后重试",
    sdkDownloadLinkMissing: "未能获取下载链接，请稍后重试",
    sdkModalTitle: "下载SDK",
    sdkModalDesc: "请选择您需要的SDK版本：",
    sdkPlatformLinux: "x86_64版本",
    sdkPlatformWindowsComing: "ARM版本",
    sdkPlatformMacComing: "Windows版本 (敬请期待)",
    
    // Numbers Component
    numbersTag: "数据统计",
    numbersTitle: "来自于新一代人工智能技术的强大产品性能",
    numbersDesc: "我们的产品可以被嵌入到自动化设备、机器人设备、广义机器人设备等多个领域，实现生产力的提升。",
    numbersStat1: "新增应用领域",
    numbersStat2: "嵌入设备数",
    numbersStat3: "企业用户数",
    numbersStat4: "活终端用户数",
    
    // FAQ Component
    faqTag: "常见问题",
    faqTitle: "常见问题解答",
    faqDesc: "关于AI智能软件服务的常见问题，帮助您更好地了解我们的产品和服务。",
    faqQ1: "AI智能软件服务可以嵌入到哪些类型的电子产品中？",
    faqA1: "我们的AI智能软件服务可以嵌入到各种电子产品中，包括智能家电、智能穿戴设备、智能家居控制系统、智能汽车等。",
    faqQ2: "嵌入AI智能软件服务需要多长时间？",
    faqA2: "集成时间取决于产品的复杂性和开发团队的经验，一般来说，简单产品可以在1-2周内完成集成，复杂产品可能需要1-2个月。",
    faqQ3: "AI智能软件服务的费用如何计算？",
    faqA3: "我们提供灵活的收费模式，包括一次性授权费、按设备数量收费、按使用量收费等，具体费用根据您的需求和规模而定。",
    faqQ4: "AI智能软件服务支持哪些语言？",
    faqA4: "我们的AI智能软件服务支持多种语言，包括中文、英文、日语、韩语等，您可以根据产品需求选择合适的语言。",
    faqQ5: "如何保证AI智能软件服务的稳定性和安全性？",
    faqA5: "我们采用了多层次的安全防护机制，包括数据加密、访问控制、定期安全审计等，确保AI服务的稳定性和安全性。",
    faqQ6: "提供哪些技术支持和服务？",
    faqA6: "我们提供全面的技术支持和服务，包括SDK集成指导、开发文档、API支持、在线培训、7x24小时技术支持等。",
    
    // Pricing Component
    pricingTag: "价格方案",
    pricingTitle: "灵活的价格方案，满足不同需求",
    pricingDesc: "根据您的产品规模和需求，选择适合的价格方案",
    pricingTrialTitle: "试用版",
    pricingStandardTitle: "标准版",
    pricingEnterpriseTitle: "企业版",
    pricingHotTag: "热门推荐",
    pricingPerMonth: "每月",
    pricingPerYear: "每年",
    pricingPerDeviceMonth: "月/设备",
    pricingTrialPrice: "10",
    pricingTrialValidity: "有效期24h",
    pricingTrialPeriod: "试用期24小时",
    pricingTrialDesc: "象征性付费一元即可体验",
    pricingStandardPrice: "100",
    pricingStandardDesc: "按时间、设备数收费，正常使用版本",
    pricingEnterprisePrice: "1000",
    pricingEnterpriseDesc: "除标准版功能外，提供更多售前指导与售后服务",
    pricingGetStarted: "开始使用",
    pricingLearnMore: "了解更多",
    pricingCurrencySymbol: "¥",
    pricingTrialFeature1: "完整开发文档与接入指南",
    pricingTrialFeature2: "基础AI能力与限量调用",
    pricingTrialFeature3: "运行状态查看与基础数据",
    pricingTrialFeature4: "试用期内完整功能体验",
    pricingStandardFeature1: "完整开发文档与API参考",
    pricingStandardFeature2: "标准AI能力与不限次调用",
    pricingStandardFeature3: "实时数据分析与可视化",
    pricingStandardFeature4: "安全防护与异常告警",
    pricingEnterpriseFeature1: "企业级文档与专属技术支持",
    pricingEnterpriseFeature2: "全量AI能力与定制化策略",
    pricingEnterpriseFeature3: "售前指导与售后服务",
    pricingEnterpriseFeature4: "企业级安全与合规保障",
    payModalTitle: "确认购买",
    payModalPlanText: "您将购买：",
    payModalPaymentMethod: "选择支付方式",
    payMethodWeChat: "微信支付",
    payMethodAlipay: "支付宝",
    payMethodBankCard: "银行卡",
    payModalCancel: "取消",
    payModalConfirm: "确认支付",
    payProcessing: "支付中...",
    payModalNote: "当前为模拟支付流程",
    paySuccessMessage: "支付成功，已开通 {plan} 正式版。",
    paySuccessDesc: "感谢您的支付，您的账户已成功开通相应服务。",
    payFailedMessage: "支付失败：{status}，请重新尝试支付。",
    payOrderFailed: "支付失败",
    payErrorInvalidData: "支付数据无效，请重试",
    payErrorFailed: "支付失败，请稍后重试",
    payModalAmountText: "金额",
    payOrderCreatedMessage: "订单创建成功",
    payOrderSuccessMessage: "订单创建成功，请扫码支付",
    payOrderQRCodeHint: "订单创建成功，请使用微信或农行APP扫码支付",
    payPollingStatus: "正在查询支付状态...",
    payOrderStatus: "订单状态",
    payOrderPending: "待支付",
    payQRCode: "支付二维码",
    payQRCodeHint: "请使用微信或农行APP扫描二维码完成支付",
    payOrderNo: "订单号",
    payCancelPayment: "取消支付",
    payModalClose: "关闭",
    payOrderDate: "订单时间",
    payProductName: "产品名称",
    payAmount: "支付金额",
    payMerchantOrderNo: "商户订单号",
    payModalClose: "关闭",
    
    // Testimonials Component
    testimonialsTag: "客户评价",
    testimonialsTitle: "客户评价",
    testimonialsDesc: "我们的AI智能软件服务已经帮助众多企业实现了产品智能化升级，以下是部分客户的真实评价。",
    testimonial1Text: "集成了AI智能软件服务后，我们的产品智能化水平大幅提升，用户体验得到了显著改善，销售额增长了25%。",
    testimonial1Name: "张小明",
    testimonial1Position: "某智能家电公司产品经理",
    testimonial2Text: "AI智能软件服务的集成非常简单，我们的开发团队只花了一周时间就完成了集成，大大降低了我们的开发成本和时间。",
    testimonial2Name: "李华",
    testimonial2Position: "某智能穿戴设备公司技术总监",
    testimonial3Text: "AI智能软件服务的数据分析功能非常强大，帮助我们实时监控设备运行状态，及时发现并解决问题，提高了产品的可靠性和稳定性。",
    testimonial3Name: "王芳",
    testimonial3Position: "某智能家居公司运营总监",
    testimonial4Text: "我们的产品集成了AI智能软件服务后，用户满意度提升了30%，重复购买率也有了显著提高。",
    testimonial4Name: "张伟",
    testimonial4Position: "某智能玩具公司CEO",
    testimonial5Text: "AI智能软件服务的语音交互功能非常出色，用户可以通过语音轻松控制我们的产品，提供了非常便捷的操作体验。",
    testimonial5Name: "刘洋",
    testimonial5Position: "某智能音箱公司产品经理",
    testimonial6Text: "AI智能软件服务的多设备互联互通功能非常强大，实现了我们产品之间的无缝协作，打造了完整的智能生态系统。",
    testimonial6Name: "陈静",
    testimonial6Position: "某智能生态公司技术负责人",
    
    // Solutions Page
    solutionsHeroTitle: "解决方案",
    solutionsHeroDesc: "基于先进的AI技术，为各行业提供智能解决方案，推动数字化转型和智能化升级",
    solutionsOverviewTag: "我们的解决方案",
    solutionsOverviewTitle: "为各行业提供智能解决方案",
    solutionsOverviewDesc: "基于先进的AI技术，我们为不同行业提供定制化的智能解决方案，帮助客户实现数字化转型和智能化升级",
    solutionsSolution1Title: "自动化系统解决方案",
    solutionsSolution1Desc: "面向工业流程的智能自动化系统，通过算法与控制策略提升稳定性、效率与一致性。",
    solutionsSolution1Feature1: "自主学习能力",
    solutionsSolution1Feature2: "多设备兼容",
    solutionsSolution2Title: "具身智能机器人",
    solutionsSolution2Desc: "为具备感知、决策与自主行为能力的机器人赋能，使之能够在复杂环境中持续学习与适应。",
    solutionsSolution2Feature1: "自然语言处理",
    solutionsSolution2Feature2: "环境感知",
    solutionsSolution2Feature3: "个性化服务",
    solutionsSolution3Title: "轻型电子设备",
    solutionsSolution3Desc: "构成轻量级智能系统底座的电子控制与嵌入式计算平台，为算法与感知提供可靠运行环境。",
    solutionsSolution3Feature1: "低功耗",
    solutionsSolution3Feature2: "边缘控制",
    solutionsSolution3Feature3: "轻量化",
    solutionsSolution3Feature4: "灵活部署",
    solutionsSolution4Title: "自动驾驶领域",
    solutionsSolution4Desc: "面向真实道路环境的自主驾驶系统，融合多传感器感知、决策规划与稳定控制，实现安全可靠的自动驾驶能力。",
    solutionsSolution4Feature1: "自主导航",
    solutionsSolution4Feature2: "多传感器融合",
    solutionsSolution4Feature3: "目标检测与跟踪",
    solutionsSolution5Title: "自主飞行设备",
    solutionsSolution5Desc: "面向真实环境的自主飞行设备，融合感知、决策与稳定控制，实现可靠的自动飞行与任务执行。",
    solutionsSolution5Feature1: "行为决策",
    solutionsSolution5Feature2: "路径规划",
    solutionsSolution5Feature3: "云端部署支持",
    solutionsSolution6Title: "工业机器人",
    solutionsSolution6Desc: "面向高精度工业场景的机器人执行系统，支持智能控制与算法驱动的稳定操作。",
    solutionsSolution6Feature1: "实时数据采集",
    solutionsSolution6Feature2: "动态场景分析",
    solutionsSolution6Feature3: "智能决策支持",
    solutionsSolution6Feature4: "持续优化升级",
    solutionsViewDetails: "了解详情",
    solutionsTechAdvantagesTag: "技术优势",
    solutionsTechAdvantagesTitle: "领先的技术实力",
    solutionsTechAdvantagesDesc: "我们拥有先进的AI技术和强大的研发团队，为客户提供高质量的智能解决方案",
    solutionsTechAdvantage1Title: "先进的芯片技术",
    solutionsTechAdvantage1Desc: "自主研发的AI芯片，具有高性能、低功耗、小体积等特点",
    solutionsTechAdvantage2Title: "强大的AI算法",
    solutionsTechAdvantage2Desc: "基于深度学习的先进算法，实现自主学习和智能决策",
    solutionsTechAdvantage3Title: "完整的生态系统",
    solutionsTechAdvantage3Desc: "提供从芯片到应用的完整解决方案，支持多种行业应用",
    solutionsTechAdvantage4Title: "高效的服务支持",
    solutionsTechAdvantage4Desc: "专业的技术团队，提供全方位的服务支持和技术咨询",
    solutionsApplicationAreasTag: "应用领域",
    solutionsApplicationAreasTitle: "覆盖各行业的智能解决方案",
    solutionsApplicationAreasDesc: "基于先进的AI技术，为各行业提供定制化智能解决方案，助力数字化转型与智能化升级。",
    solutionsIndustry1: "智能制造",
    solutionsIndustry2: "智慧农业",
    solutionsIndustry3: "智慧医疗",
    solutionsIndustry4: "智慧教育",
    solutionsIndustry5: "智慧零售",
    solutionsIndustry6: "智慧物流",
    solutionsIndustry7: "智能家居",
    solutionsIndustry8: "智慧城市",
    solutionsCaseStudiesTitle: "成功案例",
    solutionsCaseStudiesDesc: "我们的解决方案已在多个客户项目中得到应用，取得了显著的成效",
    solutionsCase1Title: "智能制造",
    solutionsCase1Desc: "帮助某制造企业实现生产线智能化改造，生产效率提升30%",
    solutionsCase1Client: "某大型制造企业",
    solutionsCase2Title: "智慧农业",
    solutionsCase2Desc: "为某农场提供智能灌溉和作物监测系统，水资源节约40%",
    solutionsCase2Client: "某现代化农场",
    solutionsCase3Title: "服务机器人",
    solutionsCase3Desc: "为酒店行业提供智能服务机器人，提升客户体验",
    solutionsCase3Client: "某连锁酒店集团",
    solutionsViewMoreCases: "查看更多案例",
    solutionsCTATitle: "准备好开始您的智能化之旅了吗？",
    solutionsCTADesc: "联系我们，了解更多关于我们的智能解决方案，让我们一起推动数字化转型和智能化升级",
    solutionsCTAButton: "立即咨询",
    
    // Technology Page
    techHeroTitle: "AI智能芯片技术",
    techHeroDesc: "像科幻电影一样，给机器人插入芯片，即可激活智能意识",
    techWhatIsAIChipTag: "什么是AI智能芯片",
    techWhatIsAIChipTitle: "机器人的智能核心",
    techWhatIsAIChipDesc: "我们的AI智能芯片是一种集成了先进人工智能技术的微型处理器，就像科幻电影中那样，只需将芯片插入机器人，即可赋予其智能意识和学习能力。",
    techFeature1Title: "微型化设计",
    techFeature1Desc: "超小体积设计，可嵌入各种尺寸的机器人和智能设备中",
    techFeature2Title: "即插即用",
    techFeature2Desc: "简单插入即可激活智能，无需复杂的编程和配置",
    techFeature3Title: "持续进化",
    techFeature3Desc: "具备自主学习能力，随着使用不断提升智能水平",
    techCoreTechTag: "核心技术要点",
    techCoreTechTitle: "突破传统的AI芯片技术",
    techCorePoint1Title: "先进的芯片架构",
    techCorePoint1Desc: "采用异构计算架构，集成CPU、GPU、NPU等多种计算单元，专为AI任务优化，实现高效并行计算。",
    techCorePoint2Title: "自主学习能力",
    techCorePoint2Desc: "内置先进的可学习模型，能够从环境中自主学习，不断优化行为模式，无需人工干预。",
    techCorePoint3Title: "实时决策系统",
    techCorePoint3Desc: "毫秒级响应速度，能够在复杂环境中实时分析、决策和执行，适应动态变化的场景。",
    techCorePoint4Title: "多设备兼容",
    techCorePoint4Desc: "支持多种硬件平台，可适配不同类型的机器人和智能设备，实现统一的智能体验。",
    techCorePoint5Title: "高级安全机制",
    techCorePoint5Desc: "内置多层次安全防护系统，保障芯片运行安全，防止恶意攻击和数据泄露。",
    techCorePoint6Title: "低功耗设计",
    techCorePoint6Desc: "优化的功耗管理系统，在保证高性能的同时，实现超长续航，适合各种移动机器人应用。",
    techComparisonTitle: "与传统AI技术对比",
    techComparisonDesc: "我们的AI智能芯片相比传统AI技术具有革命性的优势",
    techComparisonTableHeader1: "技术特性",
    techComparisonTableHeader2: "传统AI技术",
    techComparisonTableHeader3: "我们的AI智能芯片",
    techComparisonRow1Label: "学习能力",
    techComparisonRow1Col2: "需要大量数据训练，无法自主学习",
    techComparisonRow1Col3: "自主学习，从环境中不断进化",
    techComparisonRow2Label: "响应速度",
    techComparisonRow2Col2: "秒级响应，延迟高",
    techComparisonRow2Col3: "毫秒级响应，实时决策",
    techComparisonRow3Label: "应用难度",
    techComparisonRow3Col2: "需要专业团队开发，复杂配置",
    techComparisonRow3Col3: "即插即用，无需复杂编程",
    techComparisonRow4Label: "适应性",
    techComparisonRow4Col2: "固定场景，无法适应变化",
    techComparisonRow4Col3: "动态适应，应对复杂环境",
    techApplicationTag: "应用场景",
    techApplicationTitle: "广泛的应用领域",
    techApplicationDesc: "我们的AI智能芯片可应用于各种机器人和智能设备，创造无限可能",
    techApplication1Title: "服务机器人",
    techApplication1Desc: "应用于家庭服务机器人、酒店服务机器人、医疗辅助机器人等",
    techApplication2Title: "工业自动化",
    techApplication2Desc: "应用于工业机器人、自动化生产线、智能仓储系统等",
    techApplication3Title: "农业智能化",
    techApplication3Desc: "应用于农业机器人、智能灌溉系统、作物监测设备等",
    techApplication4Title: "教育领域",
    techApplication4Desc: "应用于教育机器人、智能教学设备、编程学习工具等",
    techApplication5Title: "医疗健康",
    techApplication5Desc: "应用于医疗机器人、康复辅助设备、健康监测系统等",
    techApplication6Title: "智能家居",
    techApplication6Desc: "应用于智能家电、家庭机器人、智能家居控制系统等",
    techPlatformTag: "开发平台",
    techPlatformTitle: "简单易用的开发工具",
    techPlatformDesc: "我们提供完整的开发平台，帮助开发者快速构建基于AI智能芯片的应用",
    techPlatform1Title: "可视化开发环境",
    techPlatform1Desc: "提供直观的可视化开发工具，无需复杂编程即可创建智能应用",
    techPlatform2Title: "丰富的API库",
    techPlatform2Desc: "提供全面的API和SDK，支持多种编程语言和开发框架",
    techPlatform3Title: "模拟测试工具",
    techPlatform3Desc: "内置模拟环境，可在开发阶段测试和优化AI应用",
    techPlatform4Title: "云端部署支持",
    techPlatform4Desc: "支持云端部署和远程管理，方便大规模应用部署",
    techFutureTag: "未来展望",
    techFutureTitle: "推动AI技术的未来发展",
    techFutureDesc: "我们将持续创新，不断提升AI智能芯片的性能和能力",
    techFuture1Title: "更强大的智能",
    techFuture1Desc: "持续优化算法，实现更接近人类的智能水平，具备情感理解和创造力",
    techFuture2Title: "更小的体积",
    techFuture2Desc: "采用先进的制造工艺，进一步缩小芯片体积，可嵌入更小的设备中",
    techFuture3Title: "更低的功耗",
    techFuture3Desc: "优化功耗设计，实现超长续航，满足更多移动设备的需求",
    
    // About Page
    aboutHeroTitle: "关于我们",
    aboutHeroDesc: "Stabilize-AI宁波如动科技，成立于2025年，是世界领先的人工智能技术科技公司。我们基于人工智能技术新理论，指导如何去实现真正的人工智能技术，并由此诞生的人工智能技术产品，可以被广泛的应用在自动化、机器人和智慧世界领域。",
    aboutCompanyTag: "公司介绍",
    aboutCompanyTitle: "世界领先的人工智能技术科技公司",
    aboutCompanyDesc: "Stabilize-AI宁波如动科技基于人工智能技术新理论，指导如何去实现真正的人工智能技术，并由此诞生的人工智能技术产品，可以被广泛的应用在自动化、机器人和智慧世界领域。",
    aboutMissionTitle: "我们的使命",
    aboutMissionDesc: "建立真正的人工智能，创造真正的机械\"生命\"，推动人工智能技术的进步，造福人类。",
    aboutVisionTitle: "我们的愿景",
    aboutVisionDesc: "成为通用人工智能领域的领头羊，让智慧世界连接你我，创造更美好的未来。",
    aboutGoalTitle: "我们的目标",
    aboutGoalDesc: "通过持续创新和技术突破，实现人工智能技术的广泛应用，推动各行业数字化转型。",
    aboutValuesTag: "核心价值观",
    aboutValuesTitle: "引领AI技术创新，创造智能未来",
    aboutValue1Title: "创新",
    aboutValue1Desc: "敢于尝试和创新，以超前的想法铸就人工智能的明天",
    aboutValue2Title: "技术",
    aboutValue2Desc: "拥有强大的编程能力和技术底蕴，利用自身技术为行业赋能",
    aboutValue3Title: "团队",
    aboutValue3Desc: "团队氛围融洽，组员来自全国一线技术团队，扁平化管理",
    aboutValue4Title: "责任",
    aboutValue4Desc: "致力于推动人工智能技术的进步，造福人类社会",
    aboutTeamTag: "我们的团队",
    aboutTeamTitle: "专业的AI研发团队",
    aboutTeamDesc: "我们拥有一支来自全球各地的专业研发团队，致力于推动人工智能技术的突破和创新",
    aboutTeamMember1Name: "朱宝",
    aboutTeamMember1Role: "创始人 & CEO",
    aboutTeamMember1Desc: "人工智能领域专家，拥有10年以上大厂AI研究经验",
    aboutTeamMember2Name: "孔颖",
    aboutTeamMember2Role: "工程总监",
    aboutTeamMember2Desc: "资深软件工程师，曾主导多个大型AI项目开发",
    aboutTeamMember3Name: "张静川",
    aboutTeamMember3Role: "算法总监",
    aboutTeamMember3Desc: "机器学习专家，专注于深度学习和强化学习研究",
    aboutTeamMember4Name: "赵设计师",
    aboutTeamMember4Role: "产品设计总监",
    aboutTeamMember4Desc: "用户体验专家，致力于打造优秀的AI产品",
    aboutJoinUsTitle: "加入我们，实现真正的人工智能技术",
    aboutJoinUsDesc: "见证人工生命的诞生，与我们一起推动人工智能技术的进步",
    aboutJoinUsButton: "联系我们",
    
    // API Page
    apiHeroTitle: "API 文档",
    apiHeroDesc: "全面的API文档，帮助您快速集成我们的AI智能服务，赋能您的电子产品。",
    apiDownloadSDK: "下载SDK",
    apiViewDocs: "查看文档",
    apiOverviewTitle1: "RESTful API",
    apiOverviewDesc1: "基于RESTful设计原则，提供简洁、易用、高效的API接口。",
    apiOverviewTitle2: "安全可靠",
    apiOverviewDesc2: "采用OAuth 2.0认证机制，确保数据传输和存储的安全性。",
    apiOverviewTitle3: "高可用性",
    apiOverviewDesc3: "99.9%的可用性保证，确保您的服务持续稳定运行。",
    apiAuthMethodsTitle: "认证方式",
    apiAuthMethod1Name: "注册要求",
    apiAuthMethod1Usage: "注意：必须通过企业邮箱进行身份认证",
    apiAuthMethod1Step1: "用户使用企业邮箱注册 / 登录",
    apiAuthMethod1Step2: "获取X-API-Key",
    apiAuthMethod1Step3: "在请求头中添加 X-API-Key: YOUR_API_KEY",
    apiAuthMethod2Name: "快速开始",
    apiAuthMethod2Desc: "通过OAuth 2.0令牌进行认证",
    apiAuthMethod2Step1: "注册 / 登录，自动开通24h免费试用",
    apiAuthMethod2Step2: '点击"下载SDK"',
    apiAuthMethod2Step3: "选择 Linux / Windows / macOS",
    apiAuthMethod2Step4: "下载打开 App → 用户指南",
    apiAuthMethod2Step5: "试用结束后选择套餐购买",
    apiEndpointsTitle: "API 端点",
    apiCategoryAuthName: "认证与授权",
    apiCategoryAuthDesc: "用户注册、登录、忘记密码、注销。受保护的接口需在请求头中携带 Authorization: Bearer <token>，token 为登录后返回的 UUID 格式令牌。",
    apiEndpointRegisterSummary: "用户注册",
    apiEndpointRegisterDesc: "提交邮箱、手机号、密码、确认密码、企业名称完成注册。",
    apiEndpointLoginSummary: "用户登录",
    apiEndpointLoginDesc: "使用邮箱或手机号（email_or_phone）与密码登录，成功返回 success、message 及 token（UUID），后续请求在 Header 中携带 Authorization: Bearer <token>。",
    apiEndpointForgotPasswordSummary: "忘记密码",
    apiEndpointForgotPasswordDesc: "提交邮箱或手机号及新密码，用于重置密码。",
    apiEndpointLogoutSummary: "用户注销",
    apiEndpointLogoutDesc: "使当前 Token 失效，需在请求头携带 Authorization: Bearer <token>。",
    apiCategoryAIServiceName: "启动服务",
    apiCategoryAIServiceDesc: "SDK 启动后通过 TCP 端口提供推理服务，采用逐行 JSON 协议。流程：登录 → 会话恢复(resume) → 推理请求(可重复) → 登出(可选)。",
    apiEndpointInferenceSummary: "推理服务",
    apiEndpointInferenceDesc: "连接 SDK 监听的 TCP 端口（默认 9000），按顺序发送 JSON 行：1) 登录(login) 获取 token；2) 一次性会话恢复(resume) 设置是否恢复策略状态；3) 重复发送观测(obs)与反馈(feedback) 获取动作(action)；4) 可选登出(logout)。每行一个完整 JSON，UTF-8 编码。",
    apiEndpointAnalyzeSummary: "智能分析",
    apiEndpointAnalyzeDesc: "分析设备数据并返回智能决策结果",
    apiCategoryDevicesName: "设备管理",
    apiCategoryDevicesDesc: "管理设备信息和状态的API",
    apiEndpointDevicesListSummary: "获取设备列表",
    apiEndpointDevicesListDesc: "获取用户所有设备的列表",
    apiEndpointDeviceDetailSummary: "获取设备详情",
    apiEndpointDeviceDetailDesc: "获取指定设备的详细信息",
    apiEndpointDescription: "描述",
    apiEndpointStartCommand: "启动命令",
    apiEndpointResponseFormat: "响应格式",
    apiEndpointExampleCode: "示例代码",
    apiEndpointTabRequest: "请求",
    apiEndpointTabResponse: "响应",
    apiErrorCodesTitle: "错误码",
    apiErrorCodeColumn1: "错误码",
    apiErrorCodeColumn2: "错误信息",
    apiErrorCodeColumn3: "描述",
    apiError400Desc: "请求参数错误或格式无效",
    apiError401Desc: "未提供有效的认证令牌",
    apiError403Desc: "没有权限访问该资源",
    apiError404Desc: "请求的资源不存在",
    apiError500Desc: "服务器内部错误",
    apiError502Desc: "网关错误",
    apiError503Desc: "服务暂时不可用",
    apiQuickStartTitle: "快速开始",
    apiQuickStartStep1Title: "获取API密钥",
    apiQuickStartStep1Desc: "在控制台中创建应用并获取API密钥或令牌。",
    apiQuickStartStep2Title: "选择集成方式",
    apiQuickStartStep2Desc: "选择适合您项目的SDK或直接调用REST API。",
    apiQuickStartStep3Title: "开始开发",
    apiQuickStartStep3Desc: "参考文档开始开发，利用我们的API构建智能应用。",

    // SDK 使用指南 (from SDK_USER_GUIDE.md)
    apiSdkGuideTitle: "SDK 使用指南",
    apiSdkGuideOverview: "概述",
    apiSdkGuideOverviewContent: "SDK 提供加密模型的本地推理服务。主要能力：\n• 模型保护：V5 格式加密模型，密钥通过后端下发，本地不存储明文密钥\n• 设备绑定：首次运行激活，绑定设备硬件\n• 会话密钥：SMK 24 小时有效，支持离线宽限（默认 72 小时）\n• 主动续期：SMK 剩余时间不足 10% 时自动续期",
    apiSdkGuideFlow: "使用流程",
    apiSdkGuideFlowContent: "1. 登录：获取 user_id、bearer token，写入 config.json\n2. 设备激活（首次运行）：采集硬件指纹，生成设备 ID 和密钥对，向 /api/activate 发起激活，保存设备证书和 License Token\n3. 模型加载：校验 License Token，请求或从缓存读取 SMK，用 SMK 解包 MDK，用 MDK 按需解密模型分块\n4. 推理服务：服务启动后监听指定端口，按 JSON 行协议处理请求",
    apiSdkGuideConfig: "配置",
    apiSdkGuideConfigContent: "config.json 查找顺序：可执行文件同目录 → 当前工作目录 → 用户主目录 ~/.stabilize_app_config.json。必填项：api_base_url（后端 API 根地址）、user_id、login_token。可选项：model_id。环境变量可覆盖：LICENSE_API_BASE_URL、USER_ID、LOGIN_TOKEN、MODEL_ID、SKIP_DEVICE_ACTIVATION（仅测试）、FORCE_LOGIN。",
    apiSdkGuideConfigExample: "配置示例",
    apiSdkGuideRun: "运行方式",
    apiSdkGuideRunContent: "命令行：./sdk_client --model-path model_exported_v5_backend.enc --host 127.0.0.1 --port 9000\n模型文件：将 model_exported_v5_backend.enc 放在可执行文件同目录，或使用 --model-path 指定路径。",
    apiSdkGuideProtocol: "客户端协议",
    apiSdkGuideProtocolContent: "通信方式：TCP，逐行 JSON，每行一个完整 JSON 对象，UTF-8 编码。\n请求顺序：1) 登录 {\"login\": {\"username\": \"...\", \"password\": \"...\"}} → {\"status\":\"ok\",\"token\":\"...\"}；2) 会话恢复 {\"resume\": false}；3) 推理请求 {\"obs\": [...], \"feedback\": [...]} → {\"status\":\"success\",\"action\":[...]}；4) 登出（可选）{\"cmd\":\"logout\"}。",
    apiSdkGuideRules: "规则与限制",
    apiSdkGuideRulesContent: "SMK 有效期：默认 24 小时，离线宽限默认 72 小时，剩余时间 <10% 时自动续期。License Token：需通过 /api/login 获取 login_token，过期可重新登录刷新。设备绑定：设备证书与硬件指纹绑定，更换主要硬件后需重新激活，证书与私钥存储在用户目录勿删。",
    apiSdkGuideNotes: "注意事项",
    apiSdkGuideNotesContent: "安全：勿将 config.json（含 login_token）提交版本库，生产环境使用 HTTPS，Linux 建议 chmod 600 config.json。网络：首次激活、SMK 请求、续期需访问后端，离线宽限期内可完全离线，确保本机时间正确。兼容性：打包产物依赖 GLIBC 2.31+。",
    apiSdkGuideTroubleshoot: "故障排查",
    apiSdkGuideTroubleshootContent: "登录失败：检查 api_base_url、邮箱/密码、网络与后端。设备激活失败：确认 user_id/login_token 已配置、/api/activate 可访问、有权限写入用户目录。模型加载失败：确认模型文件存在且路径正确、SMK 缓存可删除 ~/.smk_*/ 后重试、设备已激活且 License 有效。推理请求失败：检查 obs/feedback 长度、是否已完成登录和 resume 握手、查看服务端日志。",
    apiSdkGuideAppendix: "附录：目录与文件",
    apiSdkGuideAppendixContent: "~/.smk_*：SMK 缓存目录；~/.dc_*：设备证书目录；~/.dk_*：设备私钥目录。",

    apiSDKDownloading: "正在获取{platform}版本SDK下载链接...",
    apiSDKDownloadSuccess: "{platform}版本SDK下载链接已生成，下载即将开始",
    apiSDKDownloadError: "SDK下载失败: {error}",
    apiSDKNotAvailable: "{platform}版本SDK尚未发布，敬请期待！",
    apiSDKRetryLater: "请稍后重试",
    
    // Login Page
    loginWelcomeTitle: "欢迎登录",
    loginWelcomeSubtitle: "体验新一代AI技术",
    loginEmailLabel: "邮箱",
    loginEmailRequired: "请输入您的邮箱",
    loginEmailInvalid: "请输入有效的邮箱地址",
    loginEmailPlaceholder: "请输入邮箱",
    loginPasswordLabel: "密码",
    loginPasswordRequired: "请输入您的密码",
    loginPasswordMinLength: "密码长度不能少于6位",
    loginPasswordPlaceholder: "请输入密码",
    loginButton: "登录",
    loginNoAccount: "还没有账号？",
    loginRegisterNow: "立即注册",
    loginSuccess: "登录成功",
    
    // Register Page
    registerTitle: "注册账号",
    registerSubtitle: "加入我们，体验新一代人工智能技术",
    registerEmailLabel: "邮箱",
    registerEmailRequired: "请输入您的邮箱",
    registerEmailInvalid: "请输入有效的邮箱地址",
    registerEmailPlaceholder: "请输入邮箱",
    registerPasswordLabel: "密码",
    registerPasswordRequired: "请输入密码",
    registerPasswordMinLength: "密码长度不能少于8位",
    registerPasswordPlaceholder: "请输入密码",
    registerConfirmPasswordLabel: "确认密码",
    registerConfirmPasswordRequired: "请再次输入密码",
    registerConfirmPasswordMismatch: "两次输入的密码不一致",
    registerConfirmPasswordPlaceholder: "请再次输入密码",
    registerPhoneLabel: "手机号",
    registerPhoneRequired: "请输入您的手机号",
    registerPhoneInvalid: "请输入有效的手机号",
    registerPhonePlaceholder: "请输入手机号",
    registerCompanyNameLabel: "企业名称",
    registerCompanyNameRequired: "请输入企业名称",
    registerCompanyNameMinLength: "企业名称长度不能少于2个字符",
    registerCompanyNamePlaceholder: "请输入企业名称",
    registerButton: "注册",
    registerHasAccount: "已有账号？",
    registerLoginNow: "立即登录",
    registerSuccess: "注册成功",

    // Account
    accountOverview: "概览",
    accountSubscription: "订阅与支付",
    accountDevices: "授权与设备",
    accountSecurity: "账号安全",
    accountOverviewTitle: "概览 (Overview)",
    accountStatus: "账号状态",
    currentVersion: "当前版本",
    accountStatusExpiringSoon: "Expiring Soon",
    expiryTime: "到期时间",
    expiryTimeValue: "2026-06-01 18:00 (GMT+8)",
    remainingTime: "剩余时间",
    remainingTimeValue: "138 天 6 小时",
    licenseSummary: "授权摘要",
    licenseType: "授权类型",
    licenseTypeTeam: "团队版",
    deviceQuota: "设备配额",
    usedTotal: "已用/总数",
    multiDevice: "多设备",
    latestDevice: "最新激活设备",
    lastOnline: "最近在线",
    lastOnlineAgo: "10分钟前",
    viewAllDevices: "查看所有设备",
    deviceNameExample: "Jetson-01",
    importantNotices: "重要提醒",
    noticeTrialOnce: "试用仅限一次/账号，重复注册试用将直接封禁账号",
    noticeOfflineLimit: "离线设备最长可连续使用72小时，需在7天内至少联网一次刷新授权，否则将暂停使用",
    accountComingSoon: "敬请期待",

    // Subscription & Billing
    subscriptionTitle: "订阅与支付 (Subscription & Billing)",
    subscriptionPlan: "订阅计划",
    currentPlan: "当前计划",
    planPro: "Pro专业版",
    billingCycle: "计费周期",
    billingYearly: "年付",
    nextBillingTime: "下次扣费时间",
    autoRenew: "自动续费",
    price: "价格",
    pricePerYear: "$99 / 年",
    btnRenew: "续费",
    btnUpgrade: "升级到企业版",
    btnDowngrade: "降级到基础版",
    btnCancelSubscription: "取消订阅",
    ordersAndInvoices: "订单与发票 (Invoices)",
    orderId: "订单号",
    orderTime: "时间",
    orderAmount: "金额",
    orderStatus: "状态",
    orderAction: "操作",
    statusPaid: "Paid",
    downloadInvoicePdf: "下载发票 (PDF)",
    resendReceiptEmail: "重发收据邮件",

    // Licenses & Devices
    licenseTitle: "授权与设备 (Licenses & Devices)",
    licenseInfo: "授权信息",
    licenseId: "License ID",
    licenseScope: "授权范围",
    licenseScopeEdge: "Edge / On-prem",
    licenseStatus: "授权状态",
    lastRefresh: "最近刷新",
    licenseValidPeriod: "授权有效期",
    ticketEpochVersion: "Ticket Epoch / Version",
    btnRefreshLicense: "刷新授权",
    btnDownloadLicense: "下载授权文件",
    btnCopyActivationCode: "复制激活码",
    deviceBinding: "设备绑定 (Device Binding)",
    deviceName: "设备名",
    deviceId: "Device ID",
    deviceStatus: "状态",
    lastUsedTime: "最近使用时间",
    boundTime: "绑定时间",
    sdkVersion: "SDK 版本",
    statusActive: "Active",
    statusInactive: "Inactive",
    statusRevoked: "Revoked",
    deviceUnbind: "解绑",
    deviceRename: "重命名",
    deviceViewDetail: "查看详情",
    licenseRebindRule: "换绑规则：30天内最多解绑1次，频繁换绑将触发账号风控审核",

    // Device Detail
    deviceDetailTitle: "设备详情",
    deviceDetailPageTitle: "设备详情 - {name}",
    backToDeviceList: "返回设备列表",
    boundLicenseInfo: "绑定授权信息",
    licenseValidTime: "授权有效期",
    hardwareFingerprint: "硬件指纹摘要",
    deviceFingerprint: "设备指纹信息",
    systemInfo: "系统信息",
    last20Logs: "最近20条推理调用/心跳日志",
    rebindRuleTitle: "换绑规则（防账号共享）：",
    rebindRule1: "自然月内（30天）最多允许解绑1次，解绑后有7天冷却期，冷却期内无法再次解绑",
    rebindRule2: "连续3个月累计解绑超过2次，将触发账号风控审核，审核期间暂停设备使用权限",
    rebindRule3: "检测到多设备高频切换绑定（如15天内换绑超过1次），系统将自动判定为账号共享，直接封禁账号",
    rebindRule4: "设备解绑后，原设备将立即失效，新设备绑定需等待冷却期结束且在授权有效期内",
    logTime: "时间",
    logType: "类型",
    logResult: "结果",
  },
  en: {
    // Header
    home: "Home",
    technology: "Technology",
    solutions: "Solutions",
    apiDoc: "API Docs",
    about: "About",
    navSite: "Site",
    navAccount: "Account",
    login: "Login",
    logout: "Logout",
    welcome: "Welcome, ",
    
    // Footer
    footerCompanyDesc: "Stabilize-AI Ningbo Rudong Technology is a world-leading AI technology company in core technology. By providing AI technology based on new theories, we enable AI to be better applied in automation, robotics, and smart world fields, opening up vast territories for AI applications.",
    quickAccess: "Quick Access",
    subscribe: "Subscribe",
    emailPlaceholder: "Enter your email to stay connected",
    subscribeDescription: "By subscribing, you will receive the latest updates from Stabilize-AI Ningbo Rudong Technology",
    footerAddressTitle: "Address",
    footerAddress: "2F, Building 15, Phase 2, Wenchuang Port, No. 369 Dingying Road, Jiangbei District, Ningbo, Zhejiang",
    footerBusinessTitle: "Business Inquiry",
    footerBusinessDesc: "Welcome investment and business cooperation!",
    footerBusinessEmail: "business@stabilize-ai.com",
    footerJoinTitle: "We Look Forward to Your Joining!",
    footerJoinEmail: "hr@stabilize-ai.com",
    copyright: "© Stabilize-AI Ningbo Rudong Technology. All rights reserved.",
    contact: "Contact Us",
    contactModalTitle: "Leave a message, we look forward to connecting with you",
    contactModalName: "Name",
    contactModalEmail: "Email",
    contactModalNamePlaceholder: "Your Name",
    contactModalEmailPlaceholder: "Your Email",
    contactModalSubject: "Subject",
    contactModalContent: "Content",
    contactModalSend: "Submit",
    contactModalSuccess: "Sent. We will get back to you soon.",
    contactModalNameRequired: "Please enter your name",
    contactModalEmailRequired: "Please enter your email",
    contactModalEmailInvalid: "Please enter a valid email address",
    contactModalSubjectRequired: "Please enter subject",
    contactModalContentRequired: "Please enter content",
    products: "Products",
    
    // Common
    language: "Language",
    languageZh: "中文",
    languageEn: "English",
    
    // Home Page
    homeHero1Title: "Next-Generation Artificial Intelligence",
    homeHero1Desc: "True artificial intelligence with autonomous learning and exploration capabilities, possessing the intellectual attributes of natural life.",
    homeHero1Button1: "Explore Products",
    homeHero1Button2: "API Documentation",
    homeHero2Title: "Productizing Artificial Intelligence Technology",
    homeHero2Desc: "Including various product forms such as learnable automatic control models and chips, learnable models and chips.",
    homeHero2Button1: "Learn More",
    homeHero2Button2: "View Cases",
    homeHero3Title: "Providing Productivity, Empowering Robot Industry Landing",
    homeHero3Desc: "Application areas include automation, robotics, and generalized robotics.",
    homeHero3Button1: "Learn More",
    homeHero3Button2: "Contact Us",
    homeCoreFeaturesTag: "Core Features",
    homeCoreFeaturesTitle: "Powerful AI Software Service, Empowering Various Electronic Products",
    homeCoreFeaturesDesc: "An AI intelligent software service that can be embedded into various electronic products, giving your products intelligent experience and enhancing product competitiveness.",
    homeCoreFeature1: "Balance and control of double pendulum (Acrobot), demonstrating intelligent stabilization of complex systems.",
    homeCoreFeature1VideoIntro: "Little dog learning to walk: demonstrates the autonomous learning ability of learnable models in motion balance.",
    videoLoading: "Loading video…",
    homeCoreFeature2: "Path planning and navigation in complex environments; the agent explores and reaches the goal autonomously.",
    homeCoreFeature2VideoIntro: "PuppyPi learning to track target: demonstrates the ability of learnable models in visual tracking.",
    homeCoreFeature3: "Mountain car in constrained conditions; autonomous learning achieves the goal under limits.",
    homeCoreFeature3VideoIntro: "Little robot learning to walk: demonstrates the ability of learnable models in bipedal motion control.",
    homeCoreFeature4: "Snake-like multi-segment motion control for body coordination and goal tracking.",
    homeCoreFeature4VideoIntro: "Car avoids light movement: demonstrates the ability of learnable models in real-time perception and motion decision.",
    homeCoreFeature5: "Foraging and collection decisions in environment; intelligent planning of action sequences to complete tasks.",
    homeCoreFeature5VideoIntro: "Car light driving: demonstrates the ability of learnable models in environment perception and motion response.",
    homeCoreFeature6: "Multi-segment body motion control and coordination for flexible movement of continuous body.",
    homeCoreFeature6VideoIntro: "Car follows person movement: demonstrates the learnable model's capability in dynamic target perception and continuous behavior adjustment.",
    homeQuickStartTag: "Quick Start",
    homeQuickStartTitle: "Quickly Achieve Device Intelligence",
    homeQuickStartStep1Title: "Choose Products and Solutions",
    homeQuickStartStep1Desc: "Based on your device situation, choose the appropriate products and integration solutions.",
    homeQuickStartStep2Title: "Integrate Products into Your Device",
    homeQuickStartStep2Desc: "Install our products into your device, you can refer to the relevant product acquisition and usage documentation.",
    homeQuickStartStep3Title: "Test and Debug",
    homeQuickStartStep3Desc: "You can fully test and debug on your device. Since the model has autonomous learning capabilities, you may need to let it learn autonomously for a while until its performance meets your needs.",
    homeQuickStartStep4Title: "Device Release",
    homeQuickStartStep4Desc: "You can officially sell intelligent devices that meet the indicators to end customers.",
    homeSDKDownloading: "Fetching {platform} SDK download link...",
    homeSDKDownloadSuccess: "{platform} SDK download link generated, starting soon",
    homeSDKDownloadError: "SDK download failed: {error}",
    homeSDKNotAvailable: "{platform} version SDK is not yet released, please stay tuned!",
    homeSDKDownloadFailed: "SDK download failed",
    homeSDKRetryLater: "Please try again later",
    sdkDownloadLinkMissing: "Failed to get download link, please try again later",
    sdkModalTitle: "Download SDK",
    sdkModalDesc: "Please select the SDK version you need:",
    sdkPlatformLinux: "x86_64 Version",
    sdkPlatformWindowsComing: "ARM Version",
    sdkPlatformMacComing: "Windows Version (Coming soon)",
    
    // Numbers Component
    numbersTag: "Statistics",
    numbersTitle: "Powerful Product Performance from Next-Generation AI Technology",
    numbersDesc: "Our products can be embedded into automation equipment, robotics equipment, generalized robotics equipment and other fields to achieve productivity improvement.",
    numbersStat1: "New Application Areas",
    numbersStat2: "Embedded Devices",
    numbersStat3: "Enterprise Users",
    numbersStat4: "Active End Users",
    
    // FAQ Component
    faqTag: "FAQ",
    faqTitle: "Frequently Asked Questions",
    faqDesc: "Common questions about AI intelligent software services to help you better understand our products and services.",
    faqQ1: "What types of electronic products can AI intelligent software services be embedded into?",
    faqA1: "Our AI intelligent software services can be embedded into various electronic products, including smart home appliances, smart wearable devices, smart home control systems, smart cars, etc.",
    faqQ2: "How long does it take to embed AI intelligent software services?",
    faqA2: "Integration time depends on product complexity and development team experience. Generally, simple products can be integrated within 1-2 weeks, while complex products may require 1-2 months.",
    faqQ3: "How is the cost of AI intelligent software services calculated?",
    faqA3: "We provide flexible pricing models, including one-time license fees, per-device fees, usage-based fees, etc. Specific costs depend on your needs and scale.",
    faqQ4: "What languages does AI intelligent software services support?",
    faqA4: "Our AI intelligent software services support multiple languages, including Chinese, English, Japanese, Korean, etc. You can choose the appropriate language according to your product needs.",
    faqQ5: "How to ensure the stability and security of AI intelligent software services?",
    faqA5: "We have adopted multi-layered security mechanisms, including data encryption, access control, regular security audits, etc., to ensure the stability and security of AI services.",
    faqQ6: "What technical support and services are provided?",
    faqA6: "We provide comprehensive technical support and services, including SDK integration guidance, development documentation, API support, online training, 7x24 hours technical support, etc.",
    
    // Pricing Component
    pricingTag: "Pricing",
    pricingTitle: "Flexible Pricing Plans to Meet Different Needs",
    pricingDesc: "Choose the appropriate pricing plan based on your product scale and requirements",
    pricingTrialTitle: "Trial",
    pricingStandardTitle: "Standard",
    pricingEnterpriseTitle: "Enterprise",
    pricingHotTag: "Popular",
    pricingPerMonth: "per month",
    pricingPerYear: "per year",
    pricingPerDeviceMonth: "month/device",
    pricingTrialPrice: "5",
    pricingTrialValidity: "Valid 24h",
    pricingTrialPeriod: "Trial period: 24h",
    pricingTrialDesc: "Symbolic $5 to try",
    pricingStandardPrice: "50",
    pricingStandardDesc: "Standard usage, charged by time and device count",
    pricingEnterprisePrice: "500",
    pricingEnterpriseDesc: "All Standard features plus more pre-sales guidance and after-sales service",
    pricingGetStarted: "Get Started",
    pricingLearnMore: "Learn More",
    pricingCurrencySymbol: "$",
    pricingTrialFeature1: "Complete development docs and integration guide",
    pricingTrialFeature2: "Basic AI capabilities with usage limit",
    pricingTrialFeature3: "Runtime status and basic metrics",
    pricingTrialFeature4: "Full feature access during trial",
    pricingStandardFeature1: "Full development docs and API reference",
    pricingStandardFeature2: "Standard AI capabilities, unlimited calls",
    pricingStandardFeature3: "Real-time analytics and visualization",
    pricingStandardFeature4: "Security protection and anomaly alerts",
    pricingEnterpriseFeature1: "Enterprise docs and dedicated technical support",
    pricingEnterpriseFeature2: "Full AI capabilities and custom policies",
    pricingEnterpriseFeature3: "Pre-sales guidance and after-sales service",
    pricingEnterpriseFeature4: "Enterprise-grade security and compliance",
    payModalTitle: "Confirm Purchase",
    payModalPlanText: "You will purchase: ",
    payModalPaymentMethod: "Payment Method",
    payMethodWeChat: "WeChat Pay",
    payMethodAlipay: "Alipay",
    payMethodBankCard: "Bank Card",
    payModalCancel: "Cancel",
    payModalConfirm: "Pay Confirmation",
    payProcessing: "Processing...",
    payModalNote: "This is a simulated payment process",
    paySuccessMessage: "Payment successful, {plan} has been activated.",
    paySuccessDesc: "Thank you for your payment. Your account has been successfully activated with the corresponding service.",
    payFailedMessage: "Payment failed: {status}, please try again.",
    payOrderFailed: "Payment Failed",
    payErrorInvalidData: "Invalid payment data, please try again",
    payErrorFailed: "Payment failed, please try again later",
    payModalAmountText: "Amount",
    payOrderCreatedMessage: "Order created successfully",
    payOrderSuccessMessage: "Order created successfully, please scan QR code to pay",
    payOrderQRCodeHint: "Order created successfully, please scan the QR code with WeChat or ABC application to pay",
    payPollingStatus: "Checking payment status...",
    payOrderStatus: "Order Status",
    payOrderPending: "Pending",
    payQRCode: "Payment QR Code",
    payQRCodeHint: "Please scan the QR code with WeChat or ABC application to complete payment",
    payOrderNo: "Order No.",
    payCancelPayment: "Cancel Payment",
    payModalClose: "Close",
    payOrderDate: "Order Date",
    payProductName: "Product Name",
    payAmount: "Amount",
    payMerchantOrderNo: "Merchant Order No.",
    payModalClose: "Close",
    
    // Testimonials Component
    testimonialsTag: "Testimonials",
    testimonialsTitle: "Customer Reviews",
    testimonialsDesc: "Our AI intelligent software services have helped many enterprises achieve intelligent product upgrades. Here are some real reviews from our customers.",
    testimonial1Text: "After integrating AI intelligent software services, our product intelligence level has significantly improved, user experience has been greatly enhanced, and sales have increased by 25%.",
    testimonial1Name: "Zhang Xiaoming",
    testimonial1Position: "Product Manager at Smart Home Appliance Company",
    testimonial2Text: "The integration of AI intelligent software services is very simple. Our development team completed the integration in just one week, greatly reducing our development costs and time.",
    testimonial2Name: "Li Hua",
    testimonial2Position: "Technical Director at Smart Wearable Device Company",
    testimonial3Text: "The data analysis capabilities of AI intelligent software services are very powerful, helping us monitor device operation status in real-time, identify and solve problems promptly, improving product reliability and stability.",
    testimonial3Name: "Wang Fang",
    testimonial3Position: "Operations Director at Smart Home Company",
    testimonial4Text: "After integrating AI intelligent software services into our products, user satisfaction increased by 30%, and repeat purchase rates have also significantly improved.",
    testimonial4Name: "Zhang Wei",
    testimonial4Position: "CEO at Smart Toy Company",
    testimonial5Text: "The voice interaction function of AI intelligent software services is excellent. Users can easily control our products through voice, providing a very convenient operating experience.",
    testimonial5Name: "Liu Yang",
    testimonial5Position: "Product Manager at Smart Speaker Company",
    testimonial6Text: "The multi-device interconnection and interoperability capabilities of AI intelligent software services are very powerful, achieving seamless collaboration between our products and building a complete intelligent ecosystem.",
    testimonial6Name: "Chen Jing",
    testimonial6Position: "Technical Lead at Smart Ecosystem Company",
    
    // Solutions Page
    solutionsHeroTitle: "Solutions",
    solutionsHeroDesc: "Based on advanced AI technology, providing intelligent solutions for various industries, driving digital transformation and intelligent upgrade",
    solutionsOverviewTag: "Our Solutions",
    solutionsOverviewTitle: "Intelligent Solutions for Various Industries",
    solutionsOverviewDesc: "Based on advanced AI technology, we provide customized intelligent solutions for different industries, helping customers achieve digital transformation and intelligent upgrade",
    solutionsSolution1Title: "Automation System Solutions",
    solutionsSolution1Desc: "Intelligent automation systems for industrial processes, enhancing stability, efficiency, and consistency through algorithms and control strategies.",
    solutionsSolution1Feature1: "Autonomous Learning",
    solutionsSolution1Feature2: "Multi-device Compatibility",
    solutionsSolution2Title: "Embodied Intelligent Robots",
    solutionsSolution2Desc: "Empowering robots with perception, decision-making, and autonomous behavior capabilities, enabling continuous learning and adaptation in complex environments.",
    solutionsSolution2Feature1: "Natural Language Processing",
    solutionsSolution2Feature2: "Environmental Perception",
    solutionsSolution2Feature3: "Personalized Services",
    solutionsSolution3Title: "Lightweight Electronic Devices",
    solutionsSolution3Desc: "Electronic control and embedded computing platforms that form the foundation of lightweight intelligent systems, providing a reliable operating environment for algorithms and perception.",
    solutionsSolution3Feature1: "Low Power Consumption",
    solutionsSolution3Feature2: "Edge Control",
    solutionsSolution3Feature3: "Lightweight",
    solutionsSolution3Feature4: "Flexible Deployment",
    solutionsSolution4Title: "Autonomous Driving",
    solutionsSolution4Desc: "Autonomous driving systems for real-world road environments, integrating multi-sensor perception, decision planning, and stable control to achieve safe and reliable autonomous driving capabilities.",
    solutionsSolution4Feature1: "Autonomous Navigation",
    solutionsSolution4Feature2: "Multi-sensor Fusion",
    solutionsSolution4Feature3: "Object Detection and Tracking",
    solutionsSolution5Title: "Autonomous Flight Devices",
    solutionsSolution5Desc: "Autonomous flight devices for real-world environments, integrating perception, decision-making, and stable control to achieve reliable automatic flight and task execution.",
    solutionsSolution5Feature1: "Behavioral Decision-making",
    solutionsSolution5Feature2: "Path Planning",
    solutionsSolution5Feature3: "Cloud Deployment Support",
    solutionsSolution6Title: "Industrial Robots",
    solutionsSolution6Desc: "Robot execution systems for high-precision industrial scenarios, supporting intelligent control and algorithm-driven stable operations.",
    solutionsSolution6Feature1: "Real-time Data Collection",
    solutionsSolution6Feature2: "Dynamic Scene Analysis",
    solutionsSolution6Feature3: "Intelligent Decision Support",
    solutionsSolution6Feature4: "Continuous Optimization and Upgrade",
    solutionsViewDetails: "View Details",
    solutionsTechAdvantagesTag: "Technical Advantages",
    solutionsTechAdvantagesTitle: "Leading Technical Strength",
    solutionsTechAdvantagesDesc: "We have advanced AI technology and a strong R&D team, providing customers with high-quality intelligent solutions",
    solutionsTechAdvantage1Title: "Advanced Chip Technology",
    solutionsTechAdvantage1Desc: "Self-developed AI chips with high performance, low power consumption, and small size",
    solutionsTechAdvantage2Title: "Powerful AI Algorithms",
    solutionsTechAdvantage2Desc: "Advanced algorithms based on deep learning, achieving autonomous learning and intelligent decision-making",
    solutionsTechAdvantage3Title: "Complete Ecosystem",
    solutionsTechAdvantage3Desc: "Providing complete solutions from chips to applications, supporting various industry applications",
    solutionsTechAdvantage4Title: "Efficient Service Support",
    solutionsTechAdvantage4Desc: "Professional technical team providing comprehensive service support and technical consulting",
    solutionsApplicationAreasTag: "Application Areas",
    solutionsApplicationAreasTitle: "Intelligent Solutions for All Industries",
    solutionsApplicationAreasDesc: "Based on advanced AI technology, we provide customized intelligent solutions for various industries to drive digital transformation and intelligent upgrade.",
    solutionsIndustry1: "Smart Manufacturing",
    solutionsIndustry2: "Smart Agriculture",
    solutionsIndustry3: "Smart Healthcare",
    solutionsIndustry4: "Smart Education",
    solutionsIndustry5: "Smart Retail",
    solutionsIndustry6: "Smart Logistics",
    solutionsIndustry7: "Smart Home",
    solutionsIndustry8: "Smart City",
    solutionsCaseStudiesTitle: "Success Cases",
    solutionsCaseStudiesDesc: "Our solutions have been applied in multiple customer projects, achieving significant results",
    solutionsCase1Title: "Smart Manufacturing",
    solutionsCase1Desc: "Helped a manufacturing enterprise achieve intelligent production line transformation, increasing production efficiency by 30%",
    solutionsCase1Client: "A Large Manufacturing Enterprise",
    solutionsCase2Title: "Smart Agriculture",
    solutionsCase2Desc: "Provided intelligent irrigation and crop monitoring systems for a farm, saving 40% of water resources",
    solutionsCase2Client: "A Modern Farm",
    solutionsCase3Title: "Service Robots",
    solutionsCase3Desc: "Provided intelligent service robots for the hotel industry, enhancing customer experience",
    solutionsCase3Client: "A Chain Hotel Group",
    solutionsViewMoreCases: "View More Cases",
    solutionsCTATitle: "Ready to Start Your Intelligent Journey?",
    solutionsCTADesc: "Contact us to learn more about our intelligent solutions, let's work together to drive digital transformation and intelligent upgrade",
    solutionsCTAButton: "Consult Now",
    
    // Technology Page
    techHeroTitle: "AI Smart Chip Technology",
    techHeroDesc: "Just like in sci-fi movies, insert a chip into a robot to activate intelligent consciousness",
    techWhatIsAIChipTag: "What is AI Smart Chip",
    techWhatIsAIChipTitle: "The Intelligent Core of Robots",
    techWhatIsAIChipDesc: "Our AI smart chip is a micro-processor integrated with advanced artificial intelligence technology. Just like in sci-fi movies, simply insert the chip into a robot to give it intelligent consciousness and learning capabilities.",
    techFeature1Title: "Miniaturized Design",
    techFeature1Desc: "Ultra-small size design that can be embedded in robots and smart devices of various sizes",
    techFeature2Title: "Plug and Play",
    techFeature2Desc: "Simply insert to activate intelligence, no complex programming or configuration required",
    techFeature3Title: "Continuous Evolution",
    techFeature3Desc: "Equipped with autonomous learning capabilities, continuously improving intelligence levels through use",
    techCoreTechTag: "Core Technology Points",
    techCoreTechTitle: "Breakthrough Traditional AI Chip Technology",
    techCorePoint1Title: "Advanced Chip Architecture",
    techCorePoint1Desc: "Adopts heterogeneous computing architecture, integrating CPU, GPU, NPU and other computing units, optimized for AI tasks, achieving efficient parallel computing.",
    techCorePoint2Title: "Autonomous Learning Capability",
    techCorePoint2Desc: "Built-in advanced learnable models that can learn autonomously from the environment, continuously optimizing behavior patterns without human intervention.",
    techCorePoint3Title: "Real-time Decision System",
    techCorePoint3Desc: "Millisecond-level response speed, capable of real-time analysis, decision-making and execution in complex environments, adapting to dynamically changing scenarios.",
    techCorePoint4Title: "Multi-device Compatibility",
    techCorePoint4Desc: "Supports multiple hardware platforms, can adapt to different types of robots and smart devices, achieving a unified intelligent experience.",
    techCorePoint5Title: "Advanced Security Mechanism",
    techCorePoint5Desc: "Built-in multi-layer security protection system to ensure chip operation security, prevent malicious attacks and data leaks.",
    techCorePoint6Title: "Low Power Design",
    techCorePoint6Desc: "Optimized power management system that ensures high performance while achieving ultra-long battery life, suitable for various mobile robot applications.",
    techComparisonTitle: "Comparison with Traditional AI Technology",
    techComparisonDesc: "Our AI smart chip has revolutionary advantages compared to traditional AI technology",
    techComparisonTableHeader1: "Technical Features",
    techComparisonTableHeader2: "Traditional AI Technology",
    techComparisonTableHeader3: "Our AI Smart Chip",
    techComparisonRow1Label: "Learning Capability",
    techComparisonRow1Col2: "Requires massive data training, cannot learn autonomously",
    techComparisonRow1Col3: "Autonomous learning, continuously evolving from the environment",
    techComparisonRow2Label: "Response Speed",
    techComparisonRow2Col2: "Second-level response, high latency",
    techComparisonRow2Col3: "Millisecond-level response, real-time decision-making",
    techComparisonRow3Label: "Application Difficulty",
    techComparisonRow3Col2: "Requires professional team development, complex configuration",
    techComparisonRow3Col3: "Plug and play, no complex programming required",
    techComparisonRow4Label: "Adaptability",
    techComparisonRow4Col2: "Fixed scenarios, cannot adapt to changes",
    techComparisonRow4Col3: "Dynamic adaptation, coping with complex environments",
    techApplicationTag: "Application Scenarios",
    techApplicationTitle: "Wide Range of Application Fields",
    techApplicationDesc: "Our AI smart chip can be applied to various robots and smart devices, creating unlimited possibilities",
    techApplication1Title: "Service Robots",
    techApplication1Desc: "Applied to home service robots, hotel service robots, medical assistant robots, etc.",
    techApplication2Title: "Industrial Automation",
    techApplication2Desc: "Applied to industrial robots, automated production lines, intelligent warehousing systems, etc.",
    techApplication3Title: "Agricultural Intelligence",
    techApplication3Desc: "Applied to agricultural robots, intelligent irrigation systems, crop monitoring equipment, etc.",
    techApplication4Title: "Education Field",
    techApplication4Desc: "Applied to educational robots, intelligent teaching equipment, programming learning tools, etc.",
    techApplication5Title: "Medical Health",
    techApplication5Desc: "Applied to medical robots, rehabilitation assistive devices, health monitoring systems, etc.",
    techApplication6Title: "Smart Home",
    techApplication6Desc: "Applied to smart home appliances, home robots, smart home control systems, etc.",
    techPlatformTag: "Development Platform",
    techPlatformTitle: "Simple and Easy-to-Use Development Tools",
    techPlatformDesc: "We provide a complete development platform to help developers quickly build applications based on AI smart chips",
    techPlatform1Title: "Visual Development Environment",
    techPlatform1Desc: "Provides intuitive visual development tools to create intelligent applications without complex programming",
    techPlatform2Title: "Rich API Library",
    techPlatform2Desc: "Provides comprehensive APIs and SDKs supporting multiple programming languages and development frameworks",
    techPlatform3Title: "Simulation Testing Tools",
    techPlatform3Desc: "Built-in simulation environment for testing and optimizing AI applications during development",
    techPlatform4Title: "Cloud Deployment Support",
    techPlatform4Desc: "Supports cloud deployment and remote management, convenient for large-scale application deployment",
    techFutureTag: "Future Vision",
    techFutureTitle: "Driving the Future Development of AI Technology",
    techFutureDesc: "We will continue to innovate and continuously improve the performance and capabilities of AI smart chips",
    techFuture1Title: "More Powerful Intelligence",
    techFuture1Desc: "Continuously optimizing algorithms to achieve intelligence levels closer to humans, with emotional understanding and creativity",
    techFuture2Title: "Smaller Size",
    techFuture2Desc: "Adopting advanced manufacturing processes to further reduce chip size, can be embedded in smaller devices",
    techFuture3Title: "Lower Power Consumption",
    techFuture3Desc: "Optimized power consumption design to achieve ultra-long battery life, meeting the needs of more mobile devices",
    
    // About Page
    aboutHeroTitle: "About Us",
    aboutHeroDesc: "Stabilize-AI Ningbo Rudong Technology, founded in 2025, is a world-leading artificial intelligence technology company. Based on new theories of artificial intelligence technology, we guide how to realize true artificial intelligence technology, and the resulting AI technology products can be widely applied in automation, robotics, and the smart world.",
    aboutCompanyTag: "Company Introduction",
    aboutCompanyTitle: "World-Leading AI Technology Company",
    aboutCompanyDesc: "Stabilize-AI Ningbo Rudong Technology is based on new theories of artificial intelligence technology, guiding how to realize true artificial intelligence technology. The resulting AI technology products can be widely applied in automation, robotics, and the smart world.",
    aboutMissionTitle: "Our Mission",
    aboutMissionDesc: "To build true artificial intelligence, create true mechanical 'life', promote the advancement of AI technology, and benefit humanity.",
    aboutVisionTitle: "Our Vision",
    aboutVisionDesc: "To become a leader in the field of general artificial intelligence, connecting the smart world, and creating a better future.",
    aboutGoalTitle: "Our Goal",
    aboutGoalDesc: "Through continuous innovation and technological breakthroughs, achieve widespread application of AI technology and promote digital transformation across industries.",
    aboutValuesTag: "Core Values",
    aboutValuesTitle: "Leading AI Technology Innovation, Creating an Intelligent Future",
    aboutValue1Title: "Innovation",
    aboutValue1Desc: "Dare to try and innovate, shaping the future of artificial intelligence with forward-thinking ideas",
    aboutValue2Title: "Technology",
    aboutValue2Desc: "Possessing strong programming capabilities and technical foundation, using our technology to empower the industry",
    aboutValue3Title: "Team",
    aboutValue3Desc: "Harmonious team atmosphere, members from top-tier technical teams nationwide, flat management structure",
    aboutValue4Title: "Responsibility",
    aboutValue4Desc: "Committed to promoting the advancement of AI technology and benefiting human society",
    aboutTeamTag: "Our Team",
    aboutTeamTitle: "Professional AI R&D Team",
    aboutTeamDesc: "We have a professional R&D team from around the world, dedicated to driving breakthroughs and innovation in AI technology",
    aboutTeamMember1Name: "Zhu Bao",
    aboutTeamMember1Role: "Founder & CEO",
    aboutTeamMember1Desc: "Expert in AI with over 10 years of AI research experience at major tech companies",
    aboutTeamMember2Name: "Kong Ying",
    aboutTeamMember2Role: "Engineering Director",
    aboutTeamMember2Desc: "Senior software engineer who has led multiple large-scale AI project developments",
    aboutTeamMember3Name: "Zhang Jingchuan",
    aboutTeamMember3Role: "Algorithm Director",
    aboutTeamMember3Desc: "Machine learning expert specializing in deep learning and reinforcement learning research",
    aboutTeamMember4Name: "Designer Zhao",
    aboutTeamMember4Role: "Product Design Director",
    aboutTeamMember4Desc: "User experience expert committed to creating excellent AI products",
    aboutJoinUsTitle: "Join Us to Realize True Artificial Intelligence Technology",
    aboutJoinUsDesc: "Witness the birth of artificial life and join us in advancing AI technology",
    aboutJoinUsButton: "Contact Us",
    
    // API Page
    apiHeroTitle: "API Documentation",
    apiHeroDesc: "Comprehensive API documentation to help you quickly integrate our AI intelligent services and empower your electronic products.",
    apiDownloadSDK: "Download SDK",
    apiViewDocs: "View Documentation",
    apiOverviewTitle1: "RESTful API",
    apiOverviewDesc1: "Based on RESTful design principles, providing concise, easy-to-use, and efficient API interfaces.",
    apiOverviewTitle2: "Secure and Reliable",
    apiOverviewDesc2: "Using OAuth 2.0 authentication mechanism to ensure the security of data transmission and storage.",
    apiOverviewTitle3: "High Availability",
    apiOverviewDesc3: "99.9% availability guarantee, ensuring your services run continuously and stably.",
    apiAuthMethodsTitle: "Authentication Methods",
    apiAuthMethod1Name: "Registration Requirements",
    apiAuthMethod1Usage: "Note: Identity authentication must be done through corporate email",
    apiAuthMethod1Step1: "User registers / logs in using corporate email",
    apiAuthMethod1Step2: "Obtain X-API-Key",
    apiAuthMethod1Step3: "Add X-API-Key: YOUR_API_KEY to request headers",
    apiAuthMethod2Name: "Quick Start",
    apiAuthMethod2Desc: "Authenticate through OAuth 2.0 tokens",
    apiAuthMethod2Step1: "Register / Log in, automatically activate 24h free trial",
    apiAuthMethod2Step2: 'Click "Download SDK"',
    apiAuthMethod2Step3: "Select Linux / Windows / macOS",
    apiAuthMethod2Step4: "Download and open App → User Guide",
    apiAuthMethod2Step5: "Choose a plan after trial ends",
    apiEndpointsTitle: "API Endpoints",
    apiCategoryAuthName: "Authentication & Authorization",
    apiCategoryAuthDesc: "User register, login, forgot password, logout. Protected endpoints require Authorization: Bearer <token> in the request header; token is the UUID returned after login.",
    apiEndpointRegisterSummary: "Register",
    apiEndpointRegisterDesc: "Submit email, phone, password, confirm_password, and company_name to register.",
    apiEndpointLoginSummary: "Login",
    apiEndpointLoginDesc: "Login with email_or_phone and password. Returns success, message, and token (UUID). Use Authorization: Bearer <token> in headers for subsequent requests.",
    apiEndpointForgotPasswordSummary: "Forgot Password",
    apiEndpointForgotPasswordDesc: "Submit email_or_phone and new_password to reset password.",
    apiEndpointLogoutSummary: "Logout",
    apiEndpointLogoutDesc: "Invalidate the current token. Requires Authorization: Bearer <token> in the request header.",
    apiCategoryAIServiceName: "Start Service",
    apiCategoryAIServiceDesc: "After SDK starts, inference is provided over TCP using line-delimited JSON. Flow: login → resume (one-time) → inference requests (repeatable) → logout (optional).",
    apiEndpointInferenceSummary: "Inference Service",
    apiEndpointInferenceDesc: "Connect to the SDK TCP port (default 9000) and send JSON lines in order: 1) login to get token; 2) resume (once) to set whether to restore policy state; 3) send obs and feedback repeatedly to get action; 4) optional logout. One JSON object per line, UTF-8.",
    apiEndpointAnalyzeSummary: "Intelligent Analysis",
    apiEndpointAnalyzeDesc: "Analyze device data and return intelligent decision results",
    apiCategoryDevicesName: "Device Management",
    apiCategoryDevicesDesc: "APIs for managing device information and status",
    apiEndpointDevicesListSummary: "Get Device List",
    apiEndpointDevicesListDesc: "Get a list of all user devices",
    apiEndpointDeviceDetailSummary: "Get Device Details",
    apiEndpointDeviceDetailDesc: "Get detailed information about a specific device",
    apiEndpointDescription: "Description",
    apiEndpointStartCommand: "Start Command",
    apiEndpointResponseFormat: "Response Format",
    apiEndpointExampleCode: "Example Code",
    apiEndpointTabRequest: "Request",
    apiEndpointTabResponse: "Response",
    apiErrorCodesTitle: "Error Codes",
    apiErrorCodeColumn1: "Error Code",
    apiErrorCodeColumn2: "Error Message",
    apiErrorCodeColumn3: "Description",
    apiError400Desc: "Invalid request parameters or format",
    apiError401Desc: "No valid authentication token provided",
    apiError403Desc: "No permission to access this resource",
    apiError404Desc: "Requested resource does not exist",
    apiError500Desc: "Internal server error",
    apiError502Desc: "Bad gateway",
    apiError503Desc: "Service temporarily unavailable",
    apiQuickStartTitle: "Quick Start",
    apiQuickStartStep1Title: "Get API Key",
    apiQuickStartStep1Desc: "Create an application in the console and obtain an API key or token.",
    apiQuickStartStep2Title: "Choose Integration Method",
    apiQuickStartStep2Desc: "Choose an SDK suitable for your project or call the REST API directly.",
    apiQuickStartStep3Title: "Start Developing",
    apiQuickStartStep3Desc: "Start developing by referring to the documentation and build intelligent applications using our API.",

    // SDK User Guide (from SDK_USER_GUIDE.md)
    apiSdkGuideTitle: "SDK User Guide",
    apiSdkGuideOverview: "Overview",
    apiSdkGuideOverviewContent: "The SDK provides local inference for encrypted models.\n• Model protection: V5 encrypted models, keys from backend, no plaintext keys stored locally\n• Device binding: First-run activation binds to device hardware\n• Session key (SMK): 24h validity, offline grace (default 72h)\n• Auto renewal: SMK auto-renews when remaining time < 10%",
    apiSdkGuideFlow: "Usage Flow",
    apiSdkGuideFlowContent: "1. Login: Get user_id and bearer token, write to config.json\n2. Device activation (first run): Collect hardware fingerprint, generate device ID and key pair, call /api/activate, save device cert and License Token\n3. Model load: Validate License Token, get SMK from cache or request, unpack MDK with SMK, decrypt model chunks with MDK\n4. Inference service: Listens on port, processes requests via JSON lines protocol",
    apiSdkGuideConfig: "Configuration",
    apiSdkGuideConfigContent: "config.json lookup order: same dir as executable → current working dir → ~/.stabilize_app_config.json. Required: api_base_url, user_id, login_token. Optional: model_id. Env vars override: LICENSE_API_BASE_URL, USER_ID, LOGIN_TOKEN, MODEL_ID, SKIP_DEVICE_ACTIVATION (test only), FORCE_LOGIN.",
    apiSdkGuideConfigExample: "Config example",
    apiSdkGuideRun: "Running",
    apiSdkGuideRunContent: "Command: ./sdk_client --model-path model_exported_v5_backend.enc --host 127.0.0.1 --port 9000\nModel file: Place model_exported_v5_backend.enc next to the executable or use --model-path.",
    apiSdkGuideProtocol: "Client Protocol",
    apiSdkGuideProtocolContent: "Transport: TCP, line-delimited JSON, UTF-8.\nOrder: 1) Login {\"login\": {\"username\": \"...\", \"password\": \"...\"}} → {\"status\":\"ok\",\"token\":\"...\"}; 2) Resume {\"resume\": false}; 3) Inference {\"obs\": [...], \"feedback\": [...]} → {\"status\":\"success\",\"action\":[...]}; 4) Logout (optional) {\"cmd\":\"logout\"}.",
    apiSdkGuideRules: "Rules & Limits",
    apiSdkGuideRulesContent: "SMK: default 24h validity, 72h offline grace, auto-renew when <10% left. License Token: obtain via /api/login, re-login to refresh. Device binding: cert bound to hardware fingerprint; re-activate after major hardware change; do not delete cert/key in user dir.",
    apiSdkGuideNotes: "Notes",
    apiSdkGuideNotesContent: "Security: Do not commit config.json (has login_token). Use HTTPS in production. Linux: chmod 600 config.json. Network: Activation, SMK request and renewal need backend; fully offline during grace period; keep system time correct. Compatibility: Build requires GLIBC 2.31+.",
    apiSdkGuideTroubleshoot: "Troubleshooting",
    apiSdkGuideTroubleshootContent: "Login failed: Check api_base_url, credentials, network. Activation failed: Ensure user_id/login_token set, /api/activate reachable, user dir writable. Model load failed: Check model file path, clear ~/.smk_*/ cache, ensure device activated and License valid. Inference failed: Check obs/feedback length, login and resume handshake done, check server logs.",
    apiSdkGuideAppendix: "Appendix: Paths",
    apiSdkGuideAppendixContent: "~/.smk_*: SMK cache; ~/.dc_*: device cert; ~/.dk_*: device private key.",

    apiSDKDownloading: "Fetching {platform} SDK download link...",
    apiSDKDownloadSuccess: "{platform} SDK download link generated, starting soon",
    apiSDKDownloadError: "SDK download failed: {error}",
    apiSDKNotAvailable: "{platform} version SDK is not yet released, please stay tuned!",
    apiSDKRetryLater: "Please try again later",
    
    // Login Page
    loginWelcomeTitle: "Welcome",
    loginWelcomeSubtitle: "Experience Next-Generation AI Technology",
    loginEmailLabel: "Email",
    loginEmailRequired: "Please enter your email",
    loginEmailInvalid: "Please enter a valid email address",
    loginEmailPlaceholder: "Enter your email",
    loginPasswordLabel: "Password",
    loginPasswordRequired: "Please enter your password",
    loginPasswordMinLength: "Password must be at least 6 characters",
    loginPasswordPlaceholder: "Enter your password",
    loginButton: "Login",
    loginNoAccount: "Don't have an account?",
    loginRegisterNow: "Register Now",
    loginSuccess: "Login successful",
    
    // Register Page
    registerTitle: "Register",
    registerSubtitle: "Join us and experience next-generation AI technology",
    registerEmailLabel: "Email",
    registerEmailRequired: "Please enter your email",
    registerEmailInvalid: "Please enter a valid email address",
    registerEmailPlaceholder: "Enter your email",
    registerPasswordLabel: "Password",
    registerPasswordRequired: "Please enter your password",
    registerPasswordMinLength: "Password must be at least 8 characters",
    registerPasswordPlaceholder: "Enter your password",
    registerConfirmPasswordLabel: "Confirm Password",
    registerConfirmPasswordRequired: "Please enter your password again",
    registerConfirmPasswordMismatch: "The two passwords do not match",
    registerConfirmPasswordPlaceholder: "Enter your password again",
    registerPhoneLabel: "Phone Number",
    registerPhoneRequired: "Please enter your phone number",
    registerPhoneInvalid: "Please enter a valid phone number",
    registerPhonePlaceholder: "Enter your phone number",
    registerCompanyNameLabel: "Company Name",
    registerCompanyNameRequired: "Please enter your company name",
    registerCompanyNameMinLength: "Company name must be at least 2 characters",
    registerCompanyNamePlaceholder: "Enter your company name",
    registerButton: "Register",
    registerHasAccount: "Already have an account?",
    registerLoginNow: "Login Now",
    registerSuccess: "Registration successful",

    // Account
    accountOverview: "Overview",
    accountSubscription: "Subscription & Payment",
    accountDevices: "Licenses & Devices",
    accountSecurity: "Account Security",
    accountOverviewTitle: "Overview",
    accountStatus: "Account Status",
    currentVersion: "Current Version",
    accountStatusExpiringSoon: "Expiring Soon",
    expiryTime: "Expiry Time",
    expiryTimeValue: "2026-06-01 18:00 (GMT+8)",
    remainingTime: "Remaining",
    remainingTimeValue: "138 days 6 hours",
    licenseSummary: "License Summary",
    licenseType: "License Type",
    licenseTypeTeam: "Team",
    deviceQuota: "Device Quota",
    usedTotal: "Used/Total",
    multiDevice: "Multi-device",
    latestDevice: "Latest Activated Device",
    lastOnline: "Last online",
    lastOnlineAgo: "10 min ago",
    viewAllDevices: "View all devices",
    deviceNameExample: "Jetson-01",
    importantNotices: "Important Notices",
    noticeTrialOnce: "Trial is limited to one per account; repeated trial registration will result in account suspension.",
    noticeOfflineLimit: "Offline devices can be used for up to 72 hours continuously; authorization must be refreshed online at least once within 7 days, otherwise usage will be suspended.",
    accountComingSoon: "Coming soon",

    // Subscription & Billing
    subscriptionTitle: "Subscription & Billing",
    subscriptionPlan: "Subscription Plan",
    currentPlan: "Current Plan",
    planPro: "Pro",
    billingCycle: "Billing Cycle",
    billingYearly: "Yearly",
    nextBillingTime: "Next Billing Date",
    autoRenew: "Auto Renew",
    price: "Price",
    pricePerYear: "$99 / year",
    btnRenew: "Renew",
    btnUpgrade: "Upgrade to Enterprise",
    btnDowngrade: "Downgrade to Basic",
    btnCancelSubscription: "Cancel Subscription",
    ordersAndInvoices: "Orders & Invoices",
    orderId: "Order ID",
    orderTime: "Date",
    orderAmount: "Amount",
    orderStatus: "Status",
    orderAction: "Action",
    statusPaid: "Paid",
    downloadInvoicePdf: "Download Invoice (PDF)",
    resendReceiptEmail: "Resend Receipt Email",

    // Licenses & Devices
    licenseTitle: "Licenses & Devices",
    licenseInfo: "License Info",
    licenseId: "License ID",
    licenseScope: "Scope",
    licenseScopeEdge: "Edge / On-prem",
    licenseStatus: "Status",
    lastRefresh: "Last Refresh",
    licenseValidPeriod: "Valid Period",
    ticketEpochVersion: "Ticket Epoch / Version",
    btnRefreshLicense: "Refresh License",
    btnDownloadLicense: "Download License File",
    btnCopyActivationCode: "Copy Activation Code",
    deviceBinding: "Device Binding",
    deviceName: "Device Name",
    deviceId: "Device ID",
    deviceStatus: "Status",
    lastUsedTime: "Last Used",
    boundTime: "Bound At",
    sdkVersion: "SDK Version",
    statusActive: "Active",
    statusInactive: "Inactive",
    statusRevoked: "Revoked",
    deviceUnbind: "Unbind",
    deviceRename: "Rename",
    deviceViewDetail: "View Details",
    licenseRebindRule: "Rebind rule: Max 1 unbind within 30 days; frequent rebinding may trigger account review.",

    // Device Detail
    deviceDetailTitle: "Device Detail",
    deviceDetailPageTitle: "Device Detail - {name}",
    backToDeviceList: "Back to device list",
    boundLicenseInfo: "Bound License Info",
    licenseValidTime: "License Valid Until",
    hardwareFingerprint: "Hardware Fingerprint",
    deviceFingerprint: "Device Fingerprint",
    systemInfo: "System Info",
    last20Logs: "Last 20 inference/heartbeat logs",
    rebindRuleTitle: "Rebind rules (anti-sharing):",
    rebindRule1: "Max 1 unbind within 30 days; 7-day cooldown after unbind, no unbind during cooldown.",
    rebindRule2: "More than 2 unbinds in 3 consecutive months triggers account review; device access suspended during review.",
    rebindRule3: "Frequent device switching (e.g. more than 1 rebind in 15 days) will be treated as account sharing and result in account suspension.",
    rebindRule4: "After unbind, the original device becomes invalid immediately; new device binding requires cooldown end and valid license.",
    logTime: "Time",
    logType: "Type",
    logResult: "Result",
  },
};

